import dropdownTemplate from './dropdown.html';

@Inject('Responsive')
class DropdownController {
  constructor() {
    this.isOpen = false;
  }

  $onInit(){
    this.position = this.position || 'left';
    this.type = this.type || 'button';
  }
}

export default class DropdownComponent {
  constructor() {
    this.controller = DropdownController;
    this.transclude = {
      buttonLabel: '?buttonLabel',
      dropdownToggle: '?dropdownToggle',
      items: '?items',
    };
    this.bindings = {
      position: '@?',
      dropdownMenuClasses: '@?',
      appendToBody: '<?',
      disabled: '<',
      type: '<?',
    };
    this.template = dropdownTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/dropdown/dropdown-component.js